(function () {
  var productId  = window.__PRODUCT_ID__;
  var allConfigs = window.__VARIANT_CONFIG__ || [];
  if (!productId) return;
  var productGid = "gid://shopify/Product/" + productId;
  var config = [];
  for (var i = 0; i < allConfigs.length; i++) {
    if (allConfigs[i].productId === productGid) config.push(allConfigs[i]);
  }
  function extractNumericId(str) {
    return String(str || "").split("/").pop().split("-").pop();
  }
  function getVariantId() {
    var input = document.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    var param = new URLSearchParams(window.location.search).get("variant");
    if (param) return String(param);
    return null;
  }
  function filterImages() {
    var variantId = getVariantId();
    if (!variantId) return;
    var fullGid = "gid://shopify/ProductVariant/" + variantId;
    var match = null;
    for (var i = 0; i < config.length; i++) {
      if (config[i].variantId === fullGid) { match = config[i]; break; }
    }
    var allowedNumericIds = [];
    var hasMapping = false;
    if (match && Array.isArray(match.imageIds) && match.imageIds.length > 0) {
      hasMapping = true;
      for (var j = 0; j < match.imageIds.length; j++) {
        allowedNumericIds.push(extractNumericId(match.imageIds[j]));
      }
    }
    var firstVisibleTarget = null;
    var galleryItems = document.querySelectorAll(".product__media-item[id]");
    for (var g = 0; g < galleryItems.length; g++) {
      var el = galleryItems[g];
      var numericId = el.id.split("-").pop();
      var show = !hasMapping || allowedNumericIds.indexOf(numericId) !== -1;
      if (show) {
        el.classList.add("vf-visible");
        el.style.display = "";
        if (!firstVisibleTarget) firstVisibleTarget = el.getAttribute("data-media-id") || "";
      } else {
        el.classList.remove("vf-visible");
        el.style.display = "none";
      }
    }
    var thumbItems = document.querySelectorAll(".thumbnail-list__item[data-target]");
    for (var t = 0; t < thumbItems.length; t++) {
      var tel = thumbItems[t];
      var thumbNum = tel.getAttribute("data-target").split("-").pop();
      var showThumb = !hasMapping || allowedNumericIds.indexOf(thumbNum) !== -1;
      if (showThumb) { tel.classList.add("vf-visible"); tel.style.display = ""; }
      else { tel.classList.remove("vf-visible"); tel.style.display = "none"; }
    }
    if (firstVisibleTarget) {
      var btn = document.querySelector('.thumbnail-list__item[data-target="' + firstVisibleTarget + '"] button');
      if (btn) setTimeout(function () { btn.click(); }, 80);
    }
  }
  function patchInput(input) {
    if (!input || input.__vfPatched) return;
    input.__vfPatched = true;
    try {
      var proto = Object.getPrototypeOf(input);
      var desc = Object.getOwnPropertyDescriptor(proto, "value");
      if (desc && desc.set) {
        var orig = desc.set;
        Object.defineProperty(input, "value", {
          configurable: true, get: desc.get,
          set: function (v) { orig.call(this, v); filterImages(); }
        });
      }
    } catch (e) {}
  }
  function waitForGallery(cb) {
    if (document.querySelector(".product__media-item[id]")) { cb(); return; }
    var obs = new MutationObserver(function () {
      if (document.querySelector(".product__media-item[id]")) { obs.disconnect(); cb(); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  function init() {
    waitForGallery(filterImages);
    document.addEventListener("variant:change", function () { setTimeout(filterImages, 80); });
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t) return;
      var name = t.getAttribute ? t.getAttribute("name") : "";
      if (name === "id" || t.type === "radio" || t.tagName === "SELECT") setTimeout(filterImages, 80);
    });
    patchInput(document.querySelector('input[name="id"]'));
    var dw = new MutationObserver(function () {
      var inp = document.querySelector('input[name="id"]');
      if (inp) patchInput(inp);
    });
    dw.observe(document.body, { childList: true, subtree: true });
    var last = getVariantId();
    setInterval(function () {
      var cur = getVariantId();
      if (cur && cur !== last) { last = cur; filterImages(); }
    }, 300);
    window.addEventListener("popstate", filterImages);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
}());